module.exports = __webpack_public_path__ + "img/bn.86672c45.svg";